import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './style.scss';
Avatar.propTypes = {
    src: PropTypes.string,
    position: PropTypes.string,
    addedClasses: PropTypes.string
};
export default function Avatar(_a) {
    var _b = _a.src, src = _b === void 0 ? '' : _b, _c = _a.position, position = _c === void 0 ? '' : _c, _d = _a.addedClasses, addedClasses = _d === void 0 ? '' : _d;
    return (React.createElement("div", { className: clsx('avatar', position, addedClasses) },
        React.createElement("div", { className: "avatar__inner", style: { backgroundImage: "url(".concat(src, ")") } })));
}
